import { createLucideIcon } from "lucide-react";
export const CheckInIcon = createLucideIcon("check-in", [
  [
    "path",
    {
      d: "M11,20H2",
      key: "ru5yw3",
    },
  ],
  [
    "path",
    {
      d: "M11,4.6v16.2c0,.6.4,1,1,1,0,0,.2,0,.2,0l6.8-1.7V5.6c0-.9-.6-1.7-1.5-1.9l-4-1c-1.1-.3-2.2.4-2.4,1.5,0,.2,0,.3,0,.5h0Z",
      key: "1467ha",
    },
  ],
  [
    "path",
    {
      d: "M11,4h-3c-1.1,0-2,.9-2,2",
      key: "13eyfs",
    },
  ],
  [
    "path",
    {
      d: "M14,12h0",
      key: "1ap40g",
    },
  ],
  [
    "path",
    {
      d: "M2,12h6",
      key: "ilci38",
    },
  ],
  [
    "path",
    {
      d: "M22,20h-3",
      key: "1vnsar",
    },
  ],
  [
    "path",
    {
      d: "M5,15l3-3-3-3",
      key: "862u8b",
    },
  ],
  [
    "path",
    {
      d: "M6,18v2",
      key: "tdr5j4",
    },
  ],
]);
